import { registerLocaleData } from '@angular/common';
import { Component } from '@angular/core';
import localeZa from '@angular/common/locales/en-ZA';
import { Title } from '@angular/platform-browser';
import { VersionService } from './framework/services/version.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';

  constructor(private titleService: Title, public route: ActivatedRoute, public router: Router, private versionService: VersionService) {

    this.titleService.setTitle("Chronodesk");
    registerLocaleData(localeZa, 'en-ZA');
  }


  ngOnInit(): void {
    this.versionService.startPolling(30000);

  }


}
